export enum AuditDocumentRequestStatusType {
    NotStarted = 0,
    Requested = 1,
    Completed = 2,
}
